import * as styles from '../Eliminator/EliminatorPaymentAlert.scss'
import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Button } from 'react-bootstrap'
import { getPaymentStatus } from '@severed-links/common.redherrings-reducers/terminator'
import RedHerringsPayPalButton from '../Payment/RedHerringsPayPalButton'
const TerminatorPayment = ({ seasonId, noticeTarget }) => {
  const dispatch = useDispatch()
  const data = useSelector(state => state.terminator.paymentStatus)
  const payPalClientId = useSelector(state => state.payment.payPalClientId)
  const paymentTarget = useRef(null)
  const [showShortcut, setShowShortcut] = useState(false)
  const [error, setError] = useState('')
  const [refresh, setRefresh] = useState(0)
  useEffect(() => {
    let active = true
    const load = async () => {
      try {
        const action = await dispatch(getPaymentStatus(seasonId))
        if (action.error) throw new Error(action.payload?.response?.message || 'Unable to load payment status.')
        if (active) setError('')
      } catch (error) { if (active) setError(terminatorErrorMessage(error)) }
    }
    load(); const timer = setInterval(load, 15000)
    return () => { active = false; clearInterval(timer) }
  }, [dispatch, seasonId, refresh])
  const current = data?.seasonId === seasonId
  const canShowPayment = current && !error && !data.paid && data.isRegistered && data.canPay && !!payPalClientId
  useEffect(() => {
    setShowShortcut(false)
    if (!canShowPayment || !noticeTarget || !paymentTarget.current || !window.IntersectionObserver) return
    const smallScreen = window.matchMedia('(max-width: 767.98px)')
    let belowViewport = false
    const update = () => setShowShortcut(smallScreen.matches && belowViewport)
    const observer = new IntersectionObserver(([entry]) => {
      belowViewport = !entry.isIntersecting && entry.boundingClientRect.top >= (entry.rootBounds?.bottom ?? window.innerHeight)
      update()
    })
    observer.observe(paymentTarget.current)
    smallScreen.addEventListener('change', update)
    return () => {
      observer.disconnect()
      smallScreen.removeEventListener('change', update)
    }
  }, [canShowPayment, noticeTarget, seasonId])
  const goToPayment = () => {
    paymentTarget.current?.querySelector('button')?.focus({ preventScroll: true })
    paymentTarget.current?.scrollIntoView({ behavior: 'instant', block: 'center' })
  }
  if (!error && (!current || data.paid || !data.isRegistered)) return null
  const paymentButton = current && data.canPay ? <RedHerringsPayPalButton contest='Terminator' seasonId={seasonId} amount={data.balance} itemNumber={data.itemNumber} receiverEmail={data.receiverEmail} description={`${data.seasonName} Terminator entry`} onAuthorizedPayment={() => setRefresh(v => v + 1)} onCancelledPayment={() => setRefresh(v => v + 1)} /> : null
  const paymentMessage = current ? `Our records show that the $${Number(data.balance).toFixed(2)} payment is due. ${data.canPay ? 'Use the button below to pay.' : 'Please contact an administrator to arrange payment.'}` : ''
  return <>
    {canShowPayment && showShortcut && noticeTarget ? createPortal(
      <Alert variant='warning' className='d-md-none'>
        <p className='mb-2'>Your ${Number(data.balance).toFixed(2)} entry fee is still due.</p>
        <Button size='sm' onClick={goToPayment}>Go to payment</Button>
      </Alert>, noticeTarget) : null}
    <Alert className={styles.container} variant={error ? 'danger' : 'warning'}>
      <Alert.Heading>{error ? 'Payment status unavailable' : 'Payment is due'}</Alert.Heading>
      <p>{error || paymentMessage}</p>
      {!error && paymentButton ? <div ref={paymentTarget} className={styles.paymentContainer}>{paymentButton}</div> : null}
    </Alert>
  </>
}
export default TerminatorPayment
